import { FC } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';
import _ from 'lodash';

const Samco: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { reDirectPage, updatePartialConfigs, isMobile } = brokerSpecificHandles;

  const { password, clientId, selectedBrokerConfig, yob, isLoading } = userConfigs;

  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return reDirectPage({ yob: _.toNumber(yob) }, false);
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />
      <UserInput
        labelValue="Password"
        id={`${broker}-password`}
        type="password"
        value={password}
        onHandleChange={(value) => updatePartialConfigs({ password: value })}
      />
      <UserInput
        labelValue="Year of Birth"
        id={`${broker}-yob`}
        value={yob ?? ''}
        onHandleChange={(value) => updatePartialConfigs({ yob: _.toNumber(value) })}
      />

      <div className="my-2 alert alert-warning py-1 px-2">
        You need an API access from your broker in order to log in to Quantman.
      </div>
      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
          Login
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default Samco;
